module.exports = "/_next/static/images/CreateYourDynamicData-a89e559ddaaac61825c5af90498f21cf.webp";